// test997
(997 && 0);
